// extracted by mini-css-extract-plugin
export default {"Badge":"NiZBuwTChwPmp7vyxI42","icon":"RHAg2IVgPsqGSFl7XAEc"};